import { css } from 'emotion';
import styled from 'react-emotion';

import { mq } from '../../global-styles';

//  ==========================================================================
//  Styles
//  ==========================================================================
export const StyledResults = styled( 'div' )`
	margin-bottom: 15px;
`;

export const StyledLoadMoreContainer = styled( 'div' )`
	margin-bottom: 30px;
	text-align:center;
	${mq.md(
		css`
			margin-bottom: 65px;
		`
	)};
`;

export const StyledResultsInfo = styled( 'div' )`
	margin-bottom: 15px;

	${mq.lg(
		css`
			margin: 30px 0 15px;
		`
	)};
`;

export const StyledResetButton = styled( 'button' )`
	cursor: pointer;
	margin-top: 1px;

	${mq.lg(
		css`
			margin-top: 7px;
		`
	)};
	&:focus:not(.focus-visible) {
		outline-width: 0;
	}
`;

export const StyledResultsInfoBlock = styled( 'div' )`
	padding-top: 15px;

	&::after {
		clear: both;
		content: '.';
		display: block;
		height: 0;
		visibility: hidden;
	}
`;

export const StyledResultsP = styled( 'p' )`
	float: left;
	margin-right: 7px;
`;

export const StyledNoResultsP = styled( 'p' )`
	margin-top: 15px;
	${mq.md(
		css`
			margin-top: 10px;
		`
	)};
`;

export const SearchForm = styled.form`
	margin-bottom: 2rem;
`;
